module.exports = __webpack_public_path__ + "static/media/item_8_11_comp.8afc7e95.png";